export const staff = [
  {
    UserId: '10000000-0000-0000-0000-000000000000',
    Comment: 'Тестовый сотрудник',
    CreatedAt: new Date().toISOString(),
    Username: 'demo-staff'
  }
];
